import GeofenceAction from './GeofenceActionModel'
import GeofenceStyleModel from './GeofenceStyleModel'
export default class GeofenceModel {
    /* tslint:disable:variable-name */
    public _id: string = ''
    public name: string = ''
    public geofence_users: any[] = []
    public geofence_actions: GeofenceAction = new GeofenceAction()
    public geofence_styles: GeofenceStyleModel = new GeofenceStyleModel()
    public geofence_angle: number = 0
    public geofence_sw_lat: number = 0
    public geofence_sw_lon: number = 0
    public geofence_ne_lat: number = 0
    public geofence_ne_lon: number = 0
    public geofence_map_zoom: number = 16
    public geofence_opacity: number = 50
    public created_at: Date = new Date()
    public updated_at: Date = new Date()
}
